/**
 * RequestSsw
 * @author Simpli CLI generator
 */
import {$, Helper, Request, Resource} from 'simpli-web-sdk'
import {RequestSswCollection} from '@/model/collection/RequestSswCollection'

/* TODO: review generated class */
export class RequestSsw extends Resource {
  idRequestPk: number = 0

  notaFiscal: string | null = null
  json: string | null = null

  get $id() {
    return this.idRequestPk
  }
  set $id(val) {
    this.idRequestPk = val
  }

  /**
   * Gets a instance of a given ID of RequestSsw
   */
  async getRequestSsw(id: number) {
    return await Request.get(`/admin/request-ssw/${id}`)
      .name('getRequestSsw')
      .as(this)
      .getData()
  }

  /**
   * Lists the instances of RequestSsw
   */
  static async listRequestSsw(params: any) {
    return await Request.get(`/admin/request-ssw`, {params})
      .name('listRequestSsw')
      .as(RequestSswCollection)
      .getData()
  }

  /**
   * Persists a new instance of RequestSsw. Use ID = 0 to create a new one,
   * or ID > 0 to update a current one
   */
  async persistRequestSsw() {
    return await Request.post(`/admin/request-ssw`, this)
      .name('persistRequestSsw')
      .asNumber()
      .getData()
  }

  /**
   * Lists the instances of RequestSsw to use it in a CSV file
   */
  static async listCsvRequestSsw(params: any) {
    return await Request.get(`/admin/request-ssw/csv`, {params})
      .name('listCsvRequestSsw')
      .as(RequestSswCollection)
      .getData()
  }
}
